
const TOUR_KEY = 'introjs_tour';
const MAX_SHOWS = 2;

const getPageName = () => {
 const currentUrl = window.location.pathname
 //console.log(currentUrl)

 switch(currentUrl) {
    case "/":
        return "dashboard"
    case "/ph/timers":
        return "timers"
    case "/ph/scratch":
        return "scratchoff"
    case "/ph/persAnimation":
        return "persAnimation"
    case "/ph/textImages":
        return "textImages"
    case "/ph/clickcounter":
        return "clickCounter"
    case "/ph/votes":
        return "votes"
    case "/ph/generator":
        return "generator"
    case "/ph/appMatch":
        return "appMatch"
    case "/ph/moodmeter":
        return "moodMeter"
    case "/ph/spinning":
        return "spinningWheel"
    case "/ph/forecasts":
        return "forecasts"
    case "/ph/timedImages":
        return "timedImages"
    case "/ph/slidingPuzzle":
        return "slidingPuzzle"
    case "/ph/variantsViewer":
        return "variantsViewer"
    case "/ph/memoryCards":
        return "memoryCards"
    default:
        return ""
 }

}

export const tourExistsForCurrentPage = () => {
    return getPageName() !== ''
}

export function shouldShowTour() {
    const pageName = getPageName()
    if (pageName === '') return false
  const count = Number(localStorage.getItem(`${TOUR_KEY}_${pageName}`) || 0);
  return count < MAX_SHOWS;
}

export function incrementTourCount() {
    const pageName = getPageName()
    if (pageName === '') return
    const key = `${TOUR_KEY}_${pageName}`
  const count = Number(localStorage.getItem(key) || 0);
  localStorage.setItem(key, String(count + 1));
}



export const showIntroJsTourForCurrentPage = (introJs, forceShow) => {
    if (shouldShowTour() || forceShow) {
        if (!forceShow) {
            //in this case we apply a small delay
            setTimeout(() => introJs.tour()
                .onExit(() => incrementTourCount())
                .setOptions({hidePrev: true}).start(), 500)

        }
        else {
            introJs.tour()
                .onExit(() => incrementTourCount())
                .setOptions({hidePrev: true}).start();

        }

    }

}
